"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionStatusModal = void 0;
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const collection_status_modal_ctrl_1 = require("./collection.status.modal.ctrl");
const collection_status_modal_style_1 = require("./collection.status.modal.style");
const status_selector_1 = require("./status.selector");
(0, theme_1.addStyles)(collection_status_modal_style_1.Style);
class CollectionStatusModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, collections) {
        super(ctx);
        this.ctrl = new collection_status_modal_ctrl_1.CollectionStatusModalCtrl(collections);
        this.statusSelector = new status_selector_1.StatusSelector();
        this.addState(this.statusSelector.inputState);
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: collection_status_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: collection_status_modal_style_1.CSS.content }, [
                (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_STATUS_CONFIRM, { count: this.ctrl.collections.length })),
                this.statusSelector.view()
            ]),
            (0, mithril_1.m)('div', { className: collection_status_modal_style_1.CSS.contentSecond }, [
                this.viewStats(),
                this.statusSelector.selectedStats()
            ])
        ]);
    }
    viewStats() {
        const actualStatuses = this.ctrl.getActualStatuses();
        return (0, mithril_1.m)('ul', { className: collection_status_modal_style_1.CSS.list }, Object.keys(actualStatuses).map(function (key) {
            const statusText = (key === 'undefined') ? 'No status' : key;
            return (0, mithril_1.m)('li', statusText + ': ' + actualStatuses[key]);
        }));
    }
    submit() {
        return this.ctrl.SetStatusCollections(this.statusSelector.selectedStatus, this.statusSelector.ctrl.allStatuses);
    }
}
exports.CollectionStatusModal = CollectionStatusModal;
//# sourceMappingURL=collection.status.modal.js.map